import mapResultsToTemplate from './mapResultsToTemplate';

const delay = time => new Promise(resolve => setTimeout(resolve, time));

/**
 * Returns a callback that handles rendering of results
 * for the currently selected type between pagination index and offset.
 * @param {Element} component
 * @param {Object} typeTemplates
 * @returns {Function}
 */
const handlePagination = (component, typeTemplates) => async () => {
    const $loader = $(component).find('.loader');
    $loader.attr('data-active', true).show();

    const typeIndex = $(component).data('typeIndex');
    const type = $(component).data('types')[typeIndex];
    const results = $(component).data('resultsByType')[type];
    const $results = $(component).find(`[data-${type}-results]`);
    const numChildren = $results.children().length;
    const index = Number($results.attr('data-index') || 0);
    const offset = Number($results.attr('data-offset') || 1000);

    if (results.length === 0) {
        $loader.hide();
        return;
    }

    let productFamilies;
    let items;

    // products need to be treated differently, because they get grouped by family.
    if (type === 'product') {
        productFamilies = mapResultsToTemplate(type, results, typeTemplates[type]);
        items = productFamilies.slice(numChildren, index + offset);
    } else {
        const slicedResults = results.slice(numChildren, index + offset);
        items = mapResultsToTemplate(type, slicedResults, typeTemplates[type]);
    }

    await delay(500); // fake some loading delay

    $results.append(items);

    const hasRemainingItems = type === 'product'
        ? numChildren + items.length < productFamilies.length
        : numChildren + items.length < results.length;
    $loader.toggle(hasRemainingItems);
    $loader.attr('data-active', false);
};

export default handlePagination;



// WEBPACK FOOTER //
// ./src/scripts/components/search/handlePagination.js